import { Component, OnInit, Input, OnChanges, SimpleChange } from '@angular/core';
import { Router } from '@angular/router'; 
import { AppService, AppSettingService } from '../../app.service';

@Component({
	selector: 'app-journey-icon',
	template: `<i (click)="goJourney()" class="fas fa-hiking jmJourney" [ngClass]="{'jmJourneyDisabled':(journeyable===false)}" ngbTooltip="{{toolTip}}" container="body" placement="{{tipPos}}"></i>`,
	styleUrls: ['./journey-icon.scss'],
	standalone: false
})
export class JourneyIconComponent implements OnInit {
	@Input() mapObjectId: string = ""; 
	@Input() journeyable: boolean = false;
	@Input() tipPos: "left" | "top" | "bottom" | "" = ""; // display tooltip at left/right/top/bottom default is empty (not display)
	@Input() doJourney: boolean = false; // when click outside text
	@Input() hasMany: boolean = false; // do nothing if has muliplte instances

	constructor(
		private router: Router
	) {}

	toolTip: string = ""

	goJourney(): void {
		if (this.journeyable && !this.hasMany) {
			//this.router.navigateByUrl("/Map?ObjectID=" + this.mapObjectId + "&IsJourneyable=true");
			window.location.href = (AppSettingService.baseUrl + "/Map?ObjectID=" + encodeURIComponent(this.mapObjectId) + "&IsJourneyable=true");
		}
	}

	ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {
		if (changes['mapObjectId']) {
			this.mapObjectId = this.mapObjectId.trim();
			this.ngOnInit();
		}
		//this watch provides a way to know if user clicked on some text, such as label from parent of this directive.
		else if (changes['doJourney']) {
			if (this.doJourney) {
				this.goJourney();
			}
		}
	}

	ngOnInit(): void {
		this.toolTip = this.tipPos === "" || this.mapObjectId === "" ? "" : "Create Journey";
	}
}
